module.exports = __webpack_public_path__ + "static/media/honors_spade-14.f5d8c5ce.png";